import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#0B0F19]">
    <div className="max-w-7xl mx-auto px-5 md:px-10 py-10 flex flex-col md:flex-row justify-between gap-4 text-sm text-slate-500">
      <p className="font-serif-lux text-xl text-slate-300">Voyage<span className="text-[#38BDF8]">Queue</span></p>
      <div className="md:text-right space-y-2">
        <p data-testid="footer-payment-notice" className="font-mono-lux text-xs">Secure payments by Stripe (test mode) · First come, first served · No drawings, no chance</p>
        <p className="text-xs">18+ US residents only · Trips not guaranteed</p>
        <nav className="flex flex-wrap md:justify-end gap-x-5 text-sm">
          {[["/terms", "terms", "Terms & Disclosures"], ["/mission", "mission", "Our mission"], ["/privacy", "privacy", "Privacy"], ["/partners", "partners", "Travel partners"]].map(([to, id, label]) => (
            <Link key={id} to={to} data-testid={`footer-${id}-link`} className="inline-block text-[#38BDF8] hover:underline py-2.5">{label}</Link>
          ))}
        </nav>
      </div>
    </div>
  </footer>
);
